/**
 * Definiuje czy przeglądarka umożliwia dostęp do geolokalizacji
 * @returns {boolean}
 */
export default function isGeolocationAvailable() {
    return !!navigator.geolocation;
}
